import { BookingNumberInfo } from './BookingNumberInfo';

export const emptyBookingNumberInfo: BookingNumberInfo = {
  customerId: '',
  cvoId: ''
};
